/**
 * The app's route-level loading state.
 *
 * Lifted out of `App.tsx` so a route guard can live in its own module and be
 * rendered by a test without dragging the whole application import graph
 * (MSAL, every lazy page) into it. Markup unchanged.
 */
export default function PageLoader() {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      minHeight: '100vh', color: 'var(--text-muted)',
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{
          width: 28, height: 28,
          border: '3px solid var(--border)', borderTopColor: 'var(--primary)',
          borderRadius: '50%', animation: 'spin 0.8s linear infinite',
          margin: '0 auto 0.75rem',
        }} />
        <span style={{ fontSize: '0.85rem' }}>Loading...</span>
      </div>
    </div>
  );
}
